import type {
  StageType,
  VehicleSearchFilters
} from "@dealer-center/inventory-pages-gvm-interface";

export const defaultSearchInput: VehicleSearchFilters = {
  page: 1,
  max: 10,
  stage: "LIVE",
  offset: 0,
  locale: "US_EN"
};

const isStageType = (value: string): value is StageType => {
  return value === "LIVE" || value === "QA";
};

export function toSearchFilters(
  queryParams: URLSearchParams
): VehicleSearchFilters {
  if (queryParams.size === 0) {
    return defaultSearchInput;
  }

  const year = Number(queryParams.get("year") ?? NaN);
  const stage = queryParams.get("stage")?.toUpperCase() ?? "LIVE";
  const page = Number(queryParams.get("page") ?? NaN);
  const max = Number(queryParams.get("max") ?? NaN);
  const offset = Number(queryParams.get("offset") ?? NaN);

  return {
    page: !isNaN(page) ? page : 1,
    max: !isNaN(max) ? max : 10,
    offset: !isNaN(offset) ? offset : 0,
    stage: isStageType(stage) ? stage : "LIVE",
    locale: queryParams.get("locale")?.toUpperCase() ?? "US_EN",
    year: !isNaN(year) && year > 999 && year < 10000 ? year : undefined,
    make: queryParams.get("make")?.toLowerCase() ?? undefined,
    model: queryParams.get("model")?.toLowerCase() ?? undefined
  };
}

export function toQueryParams(filters: VehicleSearchFilters) {
  const params = new URLSearchParams();

  params.set("stage", filters.stage);
  params.set("locale", filters.locale);
  if (filters.year) params.set("year", String(filters.year));
  if (filters.make) params.set("make", filters.make);
  if (filters.model) params.set("model", filters.model);
  params.set("max", String(filters.max));
  params.set("offset", String(filters.offset));
  params.set("page", String(filters.page));

  return params;
}
